import { apiService } from './apiService';
import { API_ENDPOINTS, ERROR_MESSAGES } from '../constants/apiConstants';

export const compatibilityService = {
  // Create compatibility
  createCompatibility: async (data, options = {}) => {
    try {
      const payload = {
        type: data.type,
        prompt: data.prompt,
        ...(options.is_comparison ? { is_comparison: true } : {})
      };
      const response = await apiService.post(API_ENDPOINTS.COMPATIBILITY, payload);

      return {
        success: true,
        data: response.data,
        message: response.data?.message || 'Compatibility created successfully'
      };
    } catch (error) {
      console.error('Create compatibility error:', error);
      return {
        success: false,
        message: error.response?.data?.message || ERROR_MESSAGES.SERVER_ERROR,
        error: error.response?.data || error.message
      };
    }
  },

  // Get all compatibilities
  getCompatibilities: async (params = {}) => {
    try {
      const config = Object.keys(params).length ? { params } : {};
      const response = await apiService.get(API_ENDPOINTS.COMPATIBILITY, config);
      return {
        success: true,
        data: response.data,
        message: response.data?.message || 'Compatibilities fetched successfully'
      };
    } catch (error) {
      console.error('Get compatibilities error:', error);
      return {
        success: false,
        message: ERROR_MESSAGES.SERVER_ERROR,
        error: error.response?.data || error.message
      };
    }
  },

  // Get by id
  getCompatibilityById: async (id, params = {}) => {
    try {
      const config = Object.keys(params).length ? { params } : {};
      const response = await apiService.get(`${API_ENDPOINTS.COMPATIBILITY}${id}`, config);
      return {
        success: true,
        data: response.data,
        message: response.data?.message || 'Compatibility fetched successfully'
      };
    } catch (error) {
      console.error('Get compatibility by id error:', error);
      return {
        success: false,
        message: ERROR_MESSAGES.SERVER_ERROR,
        error: error.response?.data || error.message
      };
    }
  },

  // Get compatibility types — use system prompt categories endpoint
  getCompatibilityTypes: async () => {
    try {
      const response = await apiService.get(`${API_ENDPOINTS.SYSTEM_PROMPT}categories`);
      return {
        success: true,
        data: response.data,
        message: response.data?.message || 'Compatibility types fetched successfully'
      };
    } catch (error) {
      console.warn('Get compatibility types error (falling back):', error.response?.status);
      return {
        success: false,
        message: error.response?.data?.message || ERROR_MESSAGES.SERVER_ERROR,
        error: error.response?.data || error.message
      };
    }
  },

  // Update compatibility
  updateCompatibility: async (id, data, options = {}) => {
    try {
      // Only send fields provided (type and/or prompt)
      const payload = {};
      if (typeof data.type !== 'undefined') payload.type = data.type;
      if (typeof data.prompt !== 'undefined') payload.prompt = data.prompt;
      if (options.is_comparison) payload.is_comparison = true;
      const response = await apiService.patch(`${API_ENDPOINTS.COMPATIBILITY}${id}`, payload);
      return {
        success: true,
        data: response.data,
        message: response.data?.message || 'Compatibility updated successfully'
      };
    } catch (error) {
      console.error('Update compatibility error:', error);
      return {
        success: false,
        message: error.response?.data?.message || ERROR_MESSAGES.SERVER_ERROR,
        error: error.response?.data || error.message
      };
    }
  },

  // Delete compatibility
  deleteCompatibility: async (id, params = {}) => {
    try {
      const config = Object.keys(params).length ? { params } : {};
      const response = await apiService.delete(`${API_ENDPOINTS.COMPATIBILITY}${id}`, config);
      return {
        success: true,
        data: response.data,
        message: response.data?.message || 'Compatibility deleted successfully'
      };
    } catch (error) {
      console.error('Delete compatibility error:', error);
      return {
        success: false,
        message: ERROR_MESSAGES.SERVER_ERROR,
        error: error.response?.data || error.message
      };
    }
  }
};

export default compatibilityService;
